import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["text"]
const _hoisted_2 = { class: "chip-tag__text" }

import { computed, useSlots } from 'vue'

export interface Props {
  text: string;
  isActive?: boolean;
  hasFill?: boolean;
  hasNoBorder?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChipTag',
  props: {
    text: null,
    isActive: { type: Boolean, default: false },
    hasFill: { type: Boolean, default: false },
    hasNoBorder: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { text: string, isActive: boolean, hasFill: boolean, hasNoBorder: boolean };




const slots = useSlots()

const hasIcon = computed(() => slots.default !== undefined)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      'chip-tag',
      {
        'chip-tag--active': __props.isActive,
        'chip-tag--icon': _unref(hasIcon),
        'chip-tag--filled': __props.hasFill,
        'chip-tag--no-border': __props.hasNoBorder
      }
    ]),
    text: __props.text
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.text), 1)
  ], 10, _hoisted_1))
}
}

})